// extracted by mini-css-extract-plugin
module.exports = {"link_wrapper":"link_wrapper-lPTPM","change_text":"change_text-x5FRg","hyperlink":"hyperlink-xCVRf"};